import React from 'react';
import Barcode from 'react-barcode';
import { BaasicInput, BaasicDropdown } from 'core/components';
import { defaultTemplate } from 'core/hoc';

function CreatePalletTemplate({
	t,
	store: {
		palletCreateForm,
		createPalletNotification,
		togglePallet,
		barcode,
		setRef,
		carrierTypeServiceTypeDropdownStore,
	},
}) {
	return (
		<section>
			<form className="ReactModal__form">
				<div className="ReactModal__body">
					<div className="spc--bottom--sml type--center">
						<Barcode format={'CODE39'} value={barcode} ref={ref => setRef(ref)} renderer={'img'} />
					</div>
					<div className="spc--bottom--sml">
						<BaasicInput field={palletCreateForm.$('name')} />
					</div>
					{createPalletNotification && createPalletNotification.includes('CONFLICT') && (
						<p className="type--color--warning spc--bottom--sml">{t(createPalletNotification)}</p>
					)}
					<BaasicDropdown
						className="spc--bottom--sml flex--grow--1"
						isClearable={false}
						dropdownStore={carrierTypeServiceTypeDropdownStore}
					/>
				</div>
				<div className="ReactModal__footer">
					<button
						className="btn btn--med btn--primary spc--bottom--sml spc--right--sml"
						type="submit"
						onClick={palletCreateForm.onSubmit}
					>
						{t('SAVE')}
					</button>
					<button className="btn btn--med btn--ghost spc--bottom--sml" type="button" onClick={togglePallet}>
						{t('BACK')}
					</button>
				</div>
			</form>
		</section>
	);
}

export default defaultTemplate(CreatePalletTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/CreatePalletTemplate.jsx